import { render, staticRenderFns } from "./ConfKeyPropertiesModal.vue?vue&type=template&id=ba4406d6&scoped=true&"
import script from "./ConfKeyPropertiesModal.vue?vue&type=script&lang=js&"
export * from "./ConfKeyPropertiesModal.vue?vue&type=script&lang=js&"
import style0 from "./ConfKeyPropertiesModal.vue?vue&type=style&index=0&id=ba4406d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba4406d6",
  null
  
)

export default component.exports